import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { Input } from '@lean-body/components/atoms';
import { SearchIcon } from '@lean-body/components/atoms/icons/search_icon';
export const InputSearch = (props) => {
    const { className, onChangeKeyword, keywordValue, submitDisabled, onSubmit, onFocus, onClick, onClickClear, autoFocus, placeholder, } = props;
    const containerClass = [className || '', css(styles.container)].join(' ');
    const onInputSubmit = (e) => {
        if (submitDisabled)
            return e.preventDefault();
        onSubmit(e);
    };
    const onInputClick = (e) => {
        e.stopPropagation();
        if (onClick)
            onClick();
    };
    return (React.createElement("div", { className: containerClass },
        React.createElement("form", { className: css(styles.inputForm), onSubmit: onInputSubmit, onFocus: onFocus, onClick: onInputClick, "data-test": "submitForm" },
            React.createElement(SearchIcon, { color: Colors.GrayDarkest, classObject: styles.searchIcon }),
            React.createElement(Input, { type: "text", onChange: (e) => onChangeKeyword(e.target.value), onClickClearBtn: onClickClear, value: keywordValue, placeholder: placeholder, containerClassObject: styles.inputWrap, classObject: styles.input, dataTest: "inputSearch", autoFocus: autoFocus, height: 40 }))));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        width: '100%',
    },
    inputForm: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        height: 40,
        border: `1px solid ${Colors.PrimaryDark}`,
        borderRadius: 20,
        padding: '0 16px',
    },
    searchIcon: {
        width: 18,
        height: 18,
        flexShrink: 0,
    },
    inputWrap: {
        flex: 1,
        minWidth: 0,
    },
    input: {
        textAlign: 'left',
        fontSize: 14,
        color: Colors.Black,
        height: 'auto',
        paddingLeft: 0,
        paddingRight: 0,
        textIndent: 0,
        letterSpacing: 'normal',
        border: 'none',
        borderRadius: 0,
        backgroundColor: 'transparent',
        ':focus': {
            border: 'none',
            boxShadow: 'none',
        },
        '::placeholder': {
            color: Colors.GrayDarkest,
            letterSpacing: 'normal',
        },
        '::-webkit-input-placeholder': {
            color: Colors.GrayDarkest,
            letterSpacing: 'normal',
        },
        '::-ms-input-placeholder': {
            color: Colors.GrayDarkest,
            letterSpacing: 'normal',
        },
    },
});
